import SignInModalEmailOnly from '@/components/modal/sign-in-modal/sign-in-modal-email-only';

const UnauthenticatedDemoFlow = () => {
  return <SignInModalEmailOnly isOpen isOnboardingRoute />;
};

export default UnauthenticatedDemoFlow;
